(function($){
  $(function(){

    // Setting Up Global Variables to be used in JS - Denotes which template is which so JavaScript is used only on proper templates
    var BODY      	      	  = $('body'),
        IS_INDEX              = (BODY.hasClass('index-template')) ? true : false,
        IS_COLLECTION         = (BODY.hasClass('collection-template')) ? true : false,
        IS_COLLECTION_LISTING = (BODY.hasClass('list-collections-template')) ? true : false,
        IS_PRODUCT            = (BODY.hasClass('product-template')) ? true : false,
        IS_PRODUCT            = (BODY.hasClass('product-template')) ? true : false,
        IS_BLOG               = (BODY.hasClass('blog-template')) ? true : false,
        IS_ARTICLE            = (BODY.hasClass('article-template')) ? true : false,
        IS_SEARCH             = (BODY.hasClass('search-template')) ? true : false,
        IS_PAGE	              = (BODY.hasClass('page-template')) ? true : false,
        IS_CART               = (BODY.hasClass('cart-template')) ? true : false,
        HAS_PRODUCTS          = ($('.product').length > 0) ? true : false;

    if(HAS_PRODUCTS){
      // Spinner
      $.fn.spin.presets.pwm = {
        lines: 12,
        length: 3,
        width: 3,
        radius: 9,
        scale: 1,
        corners: 1,
        color: '#a08958', 
        opacity: 0,
        rotate: 0,
        direction: 1,
        speed: 1.4,
        trail: 85,
        fps: 20,
        zIndex: 5000,
        className: 'spinner',
        top: '40%',
        left: '50%',
        shadow: false,
        hwaccel: false,
        position: 'absolute'
      }

      function preloadImg(src) {
        $('<img/>')[0].src = src;
      }
      $('.product').hover(function() {
        $('.product-swatch').each(function(){
          preloadImg($(this).data('variant-image'));
        });
      });

      // product swatches image swap
      $('.product-swatch').on('click', function() {
        var featured_image = "#product__image--" + $(this).data('prod-id'),
            variant_image = $(this).data('variant-image'),
            default_image = $(featured_image).data('default-image');
        if($(this).hasClass('product-swatch--selected')){
          $(this).removeClass('product-swatch--selected');
          $(featured_image).attr('src', default_image);
        }
        else {
          $(this).addClass('product-swatch--selected').siblings().removeClass('product-swatch--selected');
          $(featured_image).attr('src', variant_image);
        }
      });
    }

    // Mobile Navigation
    var mmStatus = 'closed';
    function closeMM(){
      mmStatus = 'closed';
      $('#mobile-navigation-toggle__icon').toggleClass('opened');
      $('body').removeClass('nav-opened');
    }
    function openMM(){
      mmStatus = 'opened';
      $('body').addClass('nav-opened');
      $('#mobile-navigation-toggle__icon').toggleClass('opened');
    }

    $('#mobile-navigation-toggle').on('click', function(){
      if (mmStatus == 'closed'){
        openMM();
      } else if (mmStatus == 'opened') {
        closeMM();
      }
      return false;
    });

    $('.mobile-dropdown-toggle').on('click', function(){
      $(this).toggleClass('fa-plus-circle fa-times');
      $(this).next().toggle();
    });

    // main navigation
//     $('.site-navigation-wrapper').scrollToFixed({ marginTop: -6});
    
    function toggleDD(){
      $(this).toggleClass('hovered');
      $('.sub-navigation-wrapper', this).toggleClass('sub-navigation-wrapper--shown');
    };

    var $nav = $('.site-navigation');
    var hoverConfig = {
      over: toggleDD,
      timeout: 250,
      interval: 50,
      out: toggleDD
    };

    $nav.find("li.has-sub-navigation").each(function(){
      $(this).hoverIntent(hoverConfig);
    });

    /*
    var $searchInput = $('.site-header-utility-search__form input');

    $searchInput.focusout(function(){
      $searchInput.val('');
    });

    // search autocomplete
    var cache = {};
    $searchInput.autocomplete({
      source: function(request, response){
        if (request.term in cache){
          response(cache[request.term]);
          return;
        }
        $.ajax({
          url: "/search",
          data: {
          q: "*" + request.term + "*",
          type: "product",
          view: "json",
        },
               dataType: "json",
               success: function(data){
          if (data.length){
            cache[request.term] = data;
          }
          if (data.length > 6){
            $('.ui-autocomplete').show();
          } else {
            $('.ui-autocomplete').hide();
          }
          response(data);
        }
      });
    },
	minLength: 2,
    focus: function(event, ui) {
      $('div.autoprod').removeClass('ui-state-focus');
      $('#autoprod' + ui.item.id).addClass('ui-state-focus');
    },
      select: function(event, ui){
        window.location = ui.item.url;
      },
  }).data( 'ui-autocomplete' )._renderItem = function(ul, item) {
    var elemHTML = '<div id="autoprod' + item.id +'" class="autoprod"><div class="autoimg"><img src="' + item.thumb + '" class="autothumb" /></div><div class="autotext"><h5 class="autotitle">' + item.label + '</h5><a href="' + item.url + '" class="autocollection">' + item.type + '</a><span class="autoprice">' + item.price +'</span></div>';
    return $( '<li class="ui-menu-item" role="presentation">').append(elemHTML).appendTo(ul);
  };

  $(window).on('resize', function(){
    $('.site-header-utility-search__form input').blur().val('');
  });
*/
    
  	// Makes the header nav sticky.
  	var stickyHeader = new Waypoint.Sticky({
  		element: $('.sticky-header-area')[0],
		offset: function() { return window.outerWidth >= 960 ? -6 : -4; } // Offset is based on the mobile-menu breakpoint. If the breakpoint changes, so should these numbers.
	});
    
  });
  
  
  // Call center availability functionality. Compare the times, and set classes as appropriate. Check every 2 seconds.
  function checkCallCenterStatus() {

  	var currentTime = moment().tz('America/Chicago');
    var currentDay = currentTime.day();
  	var callCenterOpenTime = currentTime.clone().hour(8).minute(0).second(0).millisecond(0);
  	var callCenterCloseTime = currentTime.clone().hour(14).minute(0).second(0).millisecond(0);
    
    if ( currentDay > 0 && currentDay < 6 && currentTime.isAfter( callCenterOpenTime ) && currentTime.isBefore( callCenterCloseTime ) ) {
      $('.call-center-section').addClass('active');
    }
    else {
      $('.call-center-section.active').removeClass('active');
    }
    
  }
  window.setInterval( checkCallCenterStatus, 2000 );
  checkCallCenterStatus();
  
  
})(jQuery)